import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  /**
   * @description
   * Sets the value of the pair identified by key to value, creating a new key/value pair if none existed for key previously.
   * The value is stringified the prevent parsing errors when retriving the item.
   *
   * @param key The identification key to pair with value.
   * @param value The value to set in store.
   * @returns Item has been set: true or false.
   */
  setItem<Type>(key: string, value: Type): boolean {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch {
      return false;
    }
  }

  /**
   * @description
   * Returns the current value associated with the given key, or null if the given key does not exist.
   *
   * @param key The key to retrieve.
   * @returns Parsed object or null.
   */
  getItem<Type>(key: string): Type | null {
    const value = localStorage.getItem(key);
    if (value) {
      try {
        return JSON.parse(value) as Type;
      } catch {
        return value as Type;
      }
    }
    return null;
  }

  clear() {
    localStorage.clear();
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
  }
}
